
const CLASS_DISABLED = "disabled"

export const initTaxonomySearch = () => {
  document.documentElement.addEventListener("shown.bs.dropdown", onDocDropdownShow);
  document.documentElement.addEventListener("input", onDocInput);
}

const onDocDropdownShow = (e) => {
  const dropdown = e.target.closest(".dropdown");
  if (dropdown && dropdown.classList.contains("searchable")) {
    // focus on search input
    const searchInput = dropdown.querySelector(".taxonomy-search-form input");
    if (searchInput) {
      searchInput.focus();
    }
  }
}

const onDocInput = (e) => {
  if (e.target.hasAttribute("data-taxonomy-live-search")) {
    const selector = e.target.dataset.wrapperSelector;
    const dropdownMenu = e.target.closest(".dropdown-menu");
    const wrapper = dropdownMenu && selector ? dropdownMenu.querySelector(selector) : null;
    if (wrapper) {
      const value = e.target.value;
      if (value) {
        filterTaxons(wrapper, value);
      } else {
        resetFilterSearch(wrapper);
      }
    }
  }
}

const filterTaxons = (wrapper, value) => {
  const taxons = getTaxons(wrapper);
  taxons.forEach(taxon => {
    const span = taxon.querySelector("[data-taxon-live-search-value]");
    const text = span.textContent || "";
    if (isTaxonMatch(text, value)) {
      taxon.classList.remove(CLASS_DISABLED);
    } else {
      taxon.classList.add(CLASS_DISABLED);
    }
  });
}

const isTaxonMatch = (text, value) => {
  let result = false;
  if (text.toLowerCase().includes(value.toLowerCase())) {
    result = true;
  } else {
    let text2 = text.toLowerCase();
    text2 = text2.replace("ą", "a");
    text2 = text2.replace("ć", "c");
    text2 = text2.replace("ę", "e");
    text2 = text2.replace("ł", "l");
    text2 = text2.replace("ń", "n");
    text2 = text2.replace("ó", "o");
    text2 = text2.replace("ś", "s");
    text2 = text2.replace("ź", "z");
    text2 = text2.replace("ż", "z");
    if (text2.includes(value.toLowerCase())) {
      result = true;
    }
  }
  return result;
}

const resetFilterSearch = (wrapper) => {
  const taxons = getTaxons(wrapper);
  taxons.forEach(taxon => {
    taxon.classList.remove(CLASS_DISABLED);
  });
}
const getTaxons = (wrapper) => {
  return wrapper.querySelectorAll("[data-taxon-live-search]");
}